import Vue from 'vue' // 引入vue
import Vuex from 'vuex' // 引入vuex
import createVuexAlong from 'vuex-along'
// 使用vuex
Vue.use(Vuex)

// 创建Vuex实例
const store = new Vuex.Store({
  state: {
    orderlistNavid: null,
    categoryId: null,
    categorySonId: null,
    categoryNav: '',
    skinPath: '',
    pathValue: '',
    skinTextHomeShow: 1, // 首页皮肤测试显示 0否 1是
    skinTextCategoryShow: 1, // 分类皮肤测试显示 0否 1是
    skinTextproductCategoryShow: 1, // 商品列表皮肤测试显示 0否 1是
    skinTextCartShow: 1, // 购物车皮肤测试显示 0否 1是
    skinTextSearchShow: 1, // 搜索页皮肤测试显示 0否 1是
    defaultSearch: '', // 默认搜索关键词
    integralIndex: 0, // 积分中心主页面-切换
    communityDetail: '', // 社区推荐商品是否显示缓存
    chooseTopic: null,
    chooseCrossSellProductItem: null,
    communityTab: 0, // 社区顶部tab索引
    communityTagsTab: 0, // 社区热门页标签索引
    communityCenterTab: 0, // 社区主页标签索引
    addCartInitData: 0, // 是否更新购物车数据
    orderInitData: 0, // 是否更新订单列表数据
    commentInitData: 0, // 是否更新商品评论列表数据
    updateIntroduce: '' // 社区个人介绍内容
  },
  mutations: {
    ORDERLIST_NAVID (state, newOrderlistNavid) { // 我的订单列表顶部导航标签切换id存储
      state.orderlistNavid = newOrderlistNavid
    },
    CATEGORY_ID (state, newCategoryId) { // 分类跳商品分类顶部导航标签切换id存储
      state.categoryId = newCategoryId
    },
    CATEGORY_SONID (state, newCategorySonId) { // 分类跳商品分类顶部导航标签切换id存储
      state.categorySonId = newCategorySonId
    },
    CATEGORY_NAV (state, newCategoryNav) { // 分类跳商品分类顶部导航标签list存储
      state.categoryNav = newCategoryNav
    },
    SKIN_PATH (state, newSkinPath) { // 皮肤测试入口所在页面路由路径
      state.skinPath = newSkinPath
    },
    PATH_VALUE (state, newPathValue) { // 所在页面登录校验路由所需参数
      state.pathValue = newPathValue
    },
    SKIN_TEXT_HOME_SHOW (state, newSkinTextHomeShow) { // 首页皮肤测试显示
      state.skinTextHomeShow = newSkinTextHomeShow
    },
    SKIN_TEXT_CATEGORY_SHOW (state, newSkinTextCategoryShow) { // 分类皮肤测试显示
      state.skinTextCategoryShow = newSkinTextCategoryShow
    },
    SKIN_TEXT_PRODUCT_CATEGORY_SHOW (state, newSkinTextproductCategoryShow) { // 商品列表皮肤测试显示
      state.skinTextproductCategoryShow = newSkinTextproductCategoryShow
    },
    SKIN_TEXT_CART_SHOW (state, newSkinTextCartShow) { // 购物车皮肤测试显示
      state.skinTextCartShow = newSkinTextCartShow
    },
    SKIN_TEXT_SEARCH_SHOW (state, newSkinTextSearchShow) { // 搜索页皮肤测试显示
      state.skinTextSearchShow = newSkinTextSearchShow
    },
    DEFAULT_SEARCH (state, newDefaultSearch) {
      state.defaultSearch = newDefaultSearch
    },
    INTEGRAL_NAVINDEX (state, integralIndex) { // 积分中心主页面-切换
      state.integralIndex = integralIndex
    },
    COMMUNITY_DETAIL (state, communityDetail) {
      state.communityDetail = communityDetail
    },
    CHOOSE_TOPIC (state, chooseTopic) {
      state.chooseTopic = chooseTopic
    },
    CHOOSE_CROSS_SELL_PRODUCT_ITEM (state, chooseCrossSellProductItem) {
      state.chooseCrossSellProductItem = chooseCrossSellProductItem
    },
    COMMUNITY_TAB (state, communityTab) {
      state.communityTab = communityTab
    },
    COMMUNITY_TAGS_TAB (state, communityTagsTab) {
      state.communityTagsTab = communityTagsTab
    },
    COMMUNITY_CENTER_TAB (state, communityCenterTab) {
      state.communityCenterTab = communityCenterTab
    },
    ADD_CART_INIT_DATA (state, addCartInitData) {
      state.addCartInitData = addCartInitData
    },
    ORDER_INIT_DATA (state, orderInitData) {
      state.orderInitData = orderInitData
    },
    COMMENT_INIT_DATA (state, commentInitData) {
      state.commentInitData = commentInitData
    },
    UPDATE_INTRODUCE (state, updateIntroduce) {
      state.updateIntroduce = updateIntroduce
    }
  },
  plugins: [createVuexAlong()]
})
// 导出store
export default store



// WEBPACK FOOTER //
// ./src/store/index.js